import Loading from 'shared/ui/Loading';
import React from 'react';
import styles from './styles.module.scss';

const FullScreenLoading = () => {
  return (
    <div className={styles.loadingContainer}>
      <Loading />
    </div>
  );
};

export default FullScreenLoading;
